import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Btn from "../../../../../components/atoms/Btn";
import Filter from "../../../../../models/Filter";
import TreeNode from "../../../../../models/TreeNode";

function CheckboxFilter({ filter, handleChange, handleHighlight, parent }) {
  const { value, color, label, id, isDisabled } = filter;
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = value && value < 1;
    }
  }, [value]);

  const handleClick = () => {
    if (!isDisabled) {
      handleChange({ ids: [id], value: value ? 0 : 1 });
    }
  };

  const handleHover = () => {
    if (!parent) {
      handleHighlight(filter?.key || null);
    }

    const selectedKeys = (parent?.childrenNodes || [])
      .filter((x) => x?.data?.value)
      .map((x) => x?.data?.key)
      .reduce((a, i) => a.add(i), new Set());

    if (selectedKeys.size === 0 || selectedKeys.has(filter.key)) {
      handleHighlight(filter?.key || null);
    } else {
      handleHighlight(null);
    }
  };

  return (
    <div className="tw-flex tw-items-center">
      <Btn
        onSubmit={handleClick}
        className=" tw-bg-transparent tw-my-px"
        onMouseMove={handleHover}
      >
        <div className="tw-flex tw-items-center tw-capitalize tw-font-semibold">
          <input
            ref={checkboxRef}
            type="checkbox"
            checked={value}
            readOnly={true}
            tabIndex={-1}
            disabled={isDisabled}
            className={isDisabled ? "tw-opacity-50 tw-pointer-events-none" : ""}
          />
          <div className="tw-w-1" />
          {color ? (
            <div
              className="tw-w-2 tw-h-2 tw-rounded-full"
              style={{ backgroundColor: color }}
            />
          ) : null}
          <div className="tw-w-1" />
          <div>{label}</div>
        </div>
      </Btn>
    </div>
  );
}

CheckboxFilter.propTypes = {
  parent: PropTypes.instanceOf(TreeNode),
  handleHighlight: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  filter: PropTypes.instanceOf(Filter).isRequired,
  isDisabled: PropTypes.bool,
};

CheckboxFilter.defaultProps = {
  handleHighlight: () => {},
  isDisabled: false,
  parent: null,
};

export default CheckboxFilter;
